import styled from "styled-components";

import Box from "./../../common/Box";

export const Wrapper = styled(Box.wrap)`
  height: 340px;
`;

export const Body = styled(Box.body)`
  font-size: 13px;
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
`;